export const mergeRetentionsWithDefaults = (
  currentRetentions,
  applicableDefaults
) => {
  const deriveKey = (r) =>
    r?.retentionKey ??
    (r?.retentionType && r?.retentionCoverageCategory
      ? `${r.retentionType}_${r.retentionCoverageCategory}`
      : undefined);

  const currentByKey = new Map(
    (currentRetentions || []).map((r) => [deriveKey(r), r]).filter(([k]) => !!k)
  );

  const mergedRetentions = [];

  (applicableDefaults || []).forEach((defaultRetention) => {
    const defaultKey = defaultRetention?.key ?? deriveKey(defaultRetention);
    const existing = defaultKey ? currentByKey.get(defaultKey) : undefined;

    const normalizedDefault = {
      ...defaultRetention,
      retentionKey: defaultKey,

      lastDefaultValue: defaultRetention?.value ?? null,
    };

    if (existing) {
      mergedRetentions.push({
        ...normalizedDefault,

        id: existing.id,
        value: existing.value,
        notes: existing.notes,

        origin: existing.origin ?? "default",

        userModified:
          existing.origin === "default"
            ? existing.value !== (defaultRetention?.value ?? null)
            : existing.userModified,
      });
    } else {
      mergedRetentions.push({
        ...normalizedDefault,
        origin: "default",
        userModified: false,
      });
    }
  });

  return mergedRetentions;
};

export const addRetentionMetadata = (retentions) => {
  return retentions.map((retention, index) => ({
    ...retention,
    originalIndex: index,
    canDelete: true,
    canRename: true,
  }));
};

export const addBlankRowIfNeeded = (retentions, blankRowId) => {
  const hasBlankRow = retentions.some(
    (r) => !r.retentionType && !r.retentionCoverageCategory && !r.value
  );

  if (!hasBlankRow && blankRowId) {
    return [
      ...retentions,
      {
        id: blankRowId,
        retentionType: "",
        retentionCoverageCategory: "",
        value: null,
        notes: null,
        canDelete: false,
        canRename: false,
        isBlank: true,
      },
    ];
  }

  return retentions;
};
